module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/357955e0e5c857b3400dc6baf539b05d.png";